import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const resources = {
  ca: {
    translation: {
      placeholder: "Poble, ciutat...",
      guess: "Endevina",
      share: "Comparteix",
      showOnGoogleMaps: "🗺️ en Google Maps",
      showOnApuntWeb: "👀 més sobre ",
      showOnApuntWeb2: " en À Punt",
      welldone: "Ben fet!",
      unknownTown: "Localitat desconeguda!",
      copy: "S'han copiat els resultats",
      showTown: "🗺️ Mostra el mapa!",
      cancelRotation: "🌀 Anul·la la rotació",
      musicGame: "Ja has endevinat la cançó de hui?",
      escutsGame: "Vols jugar ara a l'edició d'escuts?",
      settings: {
        title: "Configuració",
        distanceUnit: "Unitat de distància",
        theme: "Tema",
        difficultyModifiers: "Grau de dificultat",
        startingNextDay: "A partir de demà",
        noImageMode: "Amaga la imatge de la localitat",
        rotationMode: "Gira la imatge de manera aleatòria",
      },

      stats: {
        title: "Estadístiques",
        played: "Jugades",
        win: "Guanyades %",
        currentStreak: "Ratxa actual",
        maxStreak: "Ratxa màxima",
        averageBestDistance: "Millor distància mitjana",
        guessDistribution: "Distribució d'encerts:",
      },

      install: {
        title: "Poble CV",
        descritpionTitle: "Instal·la l'aplicació",
        description: "Afig Poble CV a la pantalla d'inici per a accedir-hi directament",
        instructionTitle: "Instruccions:",
        instructionActionOk: "D'acord",
        instructionActionCancel: "Cancel·la",
        instructionActionInstall: "Instal·la",
        instructionFirefoxAction1: "-Obri les opcions del navegador",
        instructionFirefoxAction2: "- afig a la pantalla d'inici",
        instructionFirefoxNewAction1: "- obri les opcions del navegador",
        instructionFirefoxNewAction2: '- selecciona "Instal·la"',
        instructionIdeviceAction1: "- en Safari, polsa el botó Comparteix",
        instructionIdeviceAction2: '- selecciona "Afig a la pantalla d\'inici"',
        instructionOperaAction1: "- fes clic en l'opció del menú",
        instructionOperaAction2: "- afig a la pantalla d'inici",
        instructionNotSupported: "No és compatible amb aquest navegador.",
      },
      newVersion: "Actualització disponible! <br/> Clica ací per a actualitzar!",
      updatingVersion: "Actualitzant a una nova versió...",
    }, 
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    interpolation: {
      escapeValue: false,
    },
    fallbackLng: "ca",
  });

export default i18n;
